<div class="iframe-loader-container">
  <div class="loader-content">
    <div class="spinner"></div>
    <p class="loading-text">Cargando...</p>
  </div>
</div>
